import axios from "axios";
import { useCallback, useEffect, useLayoutEffect, useState,useRef } from "react";
import debounce from "lodash/debounce";
import "./ModifyUser.css";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/Footer";
import { Col, Form, Row } from "react-bootstrap";
import Loader from "../../components/Loader/Loader";
import { confirmToast } from "../../components/ConfirmToast/ConfirmToast";
import { toast } from "react-toastify";
import ModifyUserPopup from "./ModifyUserPopup";

const ModifyUser = () => {
  const token = localStorage.getItem("authToken");
  const [usersData, setUsersData] = useState([]);
  const [username, setUsername] = useState("");
  const [isLoadingUserData, setIsLoadingUserData] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [showModifyPopup, setShowModifyPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [updateLoading, setUpdateLoading] = useState(false)
  const [originalVtrs, setOriginalVtrs] = useState([]);
  const [originalEmails, setOriginalEmails] = useState([]);
  // console.log("originalVtrs",originalVtrs)
  // const [filteredVtrs, setFilteredVtrs] = useState([]);



  const fetchUserData = async (username = "") => {
    setIsLoadingUserData(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/getAllUser?username=${username}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("respnse", response);
      setUsersData(response.data);
    } catch (error) {
      console.log("error:", error);
    } finally {
      setIsLoadingUserData(false);
    }
  };

  const handleDelete = async (username, userId) => {
    const confirmed = await confirmToast(
      <>
        Are you sure you want to delete this user <strong>{username}</strong>?
      </>
    );
    if (!confirmed) return;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_LINK}/api/v1/admin/deleteUser?id=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log('response: ', response.data);
      toast.success("successfully deleted");
    } catch (error) {
      console.log("error: ", error);
      toast.error("failed!");
    } finally {
      console.log("finally");
      fetchUserData();
    }
  };

  const handleModify = (userId) => {
    const user = usersData.find((u) => u.id === userId); // or however you fetch the user
    // console.log("user",user)
    setSelectedUser(user);
    setShowModifyPopup(true);
  };


  const onSaveModify = async (updatedData) => {
    // 🟢 Ensure proper boolean handling for roles
    if (updatedData.role === "subAdmin") {
      updatedData.admin = false;
      updatedData.subAdmin = true;
    } else if (updatedData.role === "1") {
      updatedData.admin = true;
      updatedData.subAdmin = false;
    } else {
      updatedData.admin = false;
      updatedData.subAdmin = false;
    }

    // console.log("🟡 updatedData before API call:", updatedData);
    // return;

    setUpdateLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_LINK}/api/v1/auth/modifyUser`,
        {
          id: selectedUser.id,
          username: updatedData.username,
          email: updatedData.email,
          password: updatedData.password,
          admin: updatedData.admin,
          subAdmin: updatedData.subAdmin,
          companyName: updatedData.companyName,
          information: updatedData.information,
          customerSummary: updatedData.customerSummary,
          vkPlanning: updatedData.vkPlanning || false,
          ekPlanning: updatedData.ekPlanning || false,
          template: updatedData.template,
          createUser: updatedData.createUser,
          modifyUser: updatedData.modifyUser,
          vtr: updatedData.vtr,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("✅ modifyUser API response:", response.data);
      toast.success("Successfully updated!");
    } catch (error) {
      console.error("❌ Error in modifyUser API:", error);
      toast.error("Update failed!");
    } finally {
      setShowModifyPopup(false); // Close popup
      fetchUserData(username);   // Refresh user list
      setUpdateLoading(false);
    }
  };



  const fetchVtrs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_LINK}/api/v1/admin/getAllVtr`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response",response)
      setOriginalVtrs(response.data.vtrs || []);
      // setFilteredVtrs(response.data.vtrs || []);
      // setShowVtrSuggestions(true);
    } catch (error) {
      console.error("Error fetching VTRs:", error);
    }
  };

  useEffect(() => {
    fetchVtrs();
  }, []);

  const debouncedFetchUserData = useCallback(
    debounce((value) => {
      fetchUserData(value);
    }, 2000),
    [] // stable instance
  );

  useEffect(() => {
    if (username.trim() === "") {
      fetchUserData(username);
    } else {
      debouncedFetchUserData(username);
    }
    return () => {
      debouncedFetchUserData.cancel();
    };
  }, [username, debouncedFetchUserData]);


  // Email funtion code 
  const fetchEmails = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_LINK}/api/v1/admin/uniqueEmail`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response", response)
      setOriginalEmails(response.data.emails || []);
      // setFilteredEmails(response.data.emails || []);
      // setShowSuggestions(true);
    } catch (error) {
      console.error("Error fetching emails:", error);
    }
  };

  useEffect(() => {
    fetchEmails();
  }, []);


  return (
    <div className="main_container_for_modifyUser">
      <div className="main_modifyUser">
        <div className="modify_users_header_main">
          <Header />
          <div className="ModifyUser_header">
            <Row  className="ModifyUser_header_main">
              <Col lg={2} className="modifyUser_Col">
                <div>
                  <Form.Label htmlFor="username" className="user_id_text p-0 m-0 ml-1">
                    Username
                  </Form.Label>
                </div>
                <div className="ModifyUser_input">
                  <Form.Control
                    type="text"
                    id="username"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="off"
                    maxLength={15}
                  />
                </div>
              </Col>
            </Row>
            <Row  className="modifyUSer_Btn_main">
              <Col className="" lg={2}>
                <button
                  type="button"
                  className="btn btn-danger mt-4 modifyUser-rest"
                  id="modify_reset_btn"
                  onClick={() => {
                    setUsername("");
                    fetchUserData();
                  }}
                >
                  Reset
                </button>
              </Col>
            </Row>
          </div>
        </div>

        {isLoadingUserData === true ? (
          <div className="loader_in_summary">
            <Loader />
          </div>
        ) : (
          <div className="modify_users_table_main">
            <table className="modify_users-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>UpdatedAt</th>
                  <th>Modify</th>
                  <th>Delete</th>
                </tr>
              </thead>
              {usersData.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan="7" style={{ textAlign: "center" }}>
                      <h6>NO DATA FOUND</h6>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {usersData.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="modifyUser_Tabledata">{row.username}</td>
                      <td className="modifyUser_Tabledata1">{row.email}</td>
                      <td className="modifyUser_Tabledata">{row.admin === true ? "Admin" : row.subAdmin === true ? "SubAdmin" : "User"}</td>
                      <td>
                        {new Date(row.updatedAt)
                          .toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          })
                          .replace(/\//g, "-")   // replaces "/" with "-"
                          .replace(",", " at")}
                      </td>

                      <td>
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={() => handleModify(row.id)}
                        >
                          Edit
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(row.username, row.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        )}

        {showModifyPopup && selectedUser && (
          <ModifyUserPopup
            visible={showModifyPopup}
            setVisible={setShowModifyPopup}
            selectedUser={selectedUser}
            onSave={(updatedData) => onSaveModify(updatedData)}
            updateLoading={updateLoading}
            originalVtrs={originalVtrs}
            originalEmails={originalEmails}
          />
        )}
      </div>
      <Footer className="footer" />
    </div>
  );
};

export default ModifyUser;
